import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/style.less'
import "./assets/css/index.css";
import "./assets/css/markdown.css";
// import animated from "animate.css";
import './assets/font/iconfont.css'
import "./assets/css/iconfont.css";
require('./Mock')
import {parseTime} from './utils'
import vuetify from './plugins/vuetify'
import Toast from "./components/toast/index";
import "highlight.js/styles/atom-one-dark.css";
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
Vue.use(ElementUI) //使用elementUI
Vue.use(Toast);
// Vue.use(animated);
Vue.config.productionTip = false
Vue.filter('parseTime', (v) => parseTime(v,'{y}-{m}-{d}'))
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
